import { render, staticRenderFns } from "./GiftProductInfoModal.Style#Drawer.vue?vue&type=template&id=3b39fbf9&scoped=true&"
import script from "./GiftProductInfoModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./GiftProductInfoModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./GiftProductInfoModal.Style#Drawer.vue?vue&type=style&index=0&id=3b39fbf9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39fbf9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b39fbf9')) {
      api.createRecord('3b39fbf9', component.options)
    } else {
      api.reload('3b39fbf9', component.options)
    }
    module.hot.accept("./GiftProductInfoModal.Style#Drawer.vue?vue&type=template&id=3b39fbf9&scoped=true&", function () {
      api.rerender('3b39fbf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/GiftProductInfoModal.Style#Drawer.vue"
export default component.exports